export default __webpack_public_path__ + "static/media/ownerrez_step6.599f4860.jpg";